module.exports = __webpack_public_path__ + "media/typing.879f5c6f.mp3";